export const TRACKING_ATTRIBUTES = {
  trackingTrigger: 'data-track',
  trackingObject: 'data-owc-tracking-object',
};

export const VALUES = {
  anchorTag: 'A',
};

export const TRACKING_DATA_ATTRIBUTES = {
  componentAction: 'data-tracking-action',
};

export const MISSING_TRACKING_DATA = 'MISSING_DATA';
